import React, { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";

import Typography from "@mui/material/Typography";

import StyledModal from "components/Modal";
import StyledFormInput from "components/FormInput/FormInput";

import { useAppDispatch } from "store/hooks";
import {
  BankToken,
  getBankIntegrations,
  updateBankIntegrationName,
} from "store/features/bankIntegrationsSlice";

import { FormValues, validationSchema } from "./validation";

interface IntegrationNameUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  bankToken?: BankToken | null;
}

const IntegrationNameUpdateModal: React.FC<IntegrationNameUpdateModalProps> = (
  props
) => {
  const { isOpen, bankToken, onClose } = props;
  const dispatch = useAppDispatch();

  const methods = useForm<FormValues>({
    mode: "onSubmit",
    resolver: yupResolver(validationSchema),
    values: {
      name: bankToken?.name || "",
    },
  });

  useEffect(() => {
    if (!isOpen) {
      methods.reset();
    }
  }, [isOpen]);

  const onSubmit = async () => {
    await methods.handleSubmit(async ({ name }) => {
      if (bankToken?.bankTokenUid) {
        await dispatch(
          updateBankIntegrationName({
            bankTokenUid: bankToken.bankTokenUid,
            name,
          })
        ).unwrap();
      }

      await dispatch(getBankIntegrations()).unwrap();
      onCloseModal();
    })();
  };

  const onCloseModal = () => {
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title="Назва"
      content={
        <>
          <FormProvider {...methods}>
            <StyledFormInput
              title="Юридична назва компанії або ФОП"
              name="name"
              fullWidth
              slotProps={{ input: { inputProps: { maxLength: 256 } } }}
            />
            <Typography variant="subtitle2" color="grey800" mt={-1} mb={2}>
              Для відображення в списку інтеграції.
            </Typography>
          </FormProvider>
        </>
      }
      onAction={onSubmit}
    />
  );
};

export default IntegrationNameUpdateModal;
